import React, { useState, useEffect } from "react"
import { Spinner, Table } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"

import { ambassadorAction } from "../../pages/ambassador/ambassadorAction"

import { NoData } from "../no-data/NoData"

export const AmbassadorTable = () => {
  const dispatch = useDispatch()
  const { isLoading, ambassador } = useSelector((state) => state.ambassadorUser)
  const [shouldFetch, setShouldFetch] = useState(true)

  useEffect(() => {
    //fetch all the ambassadors
    dispatch(ambassadorAction())
    setShouldFetch(false)
  }, [shouldFetch, dispatch])

  if (isLoading) {
    return <Spinner animation="border" variant="primary" />
  }
  if (!ambassador.length) {
    return <NoData />
  }

  return (
    <div>
      <div className="">{ambassador.length} ambassador found</div>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Type</th>
            <th>email</th>
            <th>Details</th>
            <th>Added Date</th>
          </tr>
        </thead>
        <tbody>
          {ambassador.map((ambassadors, index) => (
            <tr key={ambassadors._id}>
              <td>{index + 1}</td>
              <td>{`${ambassadors.fName} ${ambassadors.lName}`}</td>
              <td>{ambassadors.type}</td>
              <td>{ambassadors.email}</td>
              <td>
                <Link to={`/ambassador/${ambassadors._id}`}>Info</Link>
              </td>
              <td>{new Date(ambassadors.createdAt).toLocaleDateString()}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  )
}
